<template>
    <v-footer :fixed="fixed" :color="$icsilab.getFooter().BackgroundColor ? $icsilab.getFooter().BackgroundColor : 'white'" padless>
        <v-flex xs12>
            <v-container grid-list-xl>
                <v-layout row wrap justify-center>
                    <div class="md3" :style="{color: $icsilab.getFooter().color ? $icsilab.getFooter().color : 'black'}">
                        © 2020 ICSILAB
                    </div>
                    <div class="md1" :style="{color: $icsilab.getFooter().color ? $icsilab.getFooter().color : 'black'}" v-html="'&nbsp;|&nbsp;'"/>
                    <div class="md4" :style="{color: $icsilab.getFooter().color ? $icsilab.getFooter().color : 'black'}">
                      {{ tous_droits_reserces_label }}
                    </div>
                    <div class="md1" :style="{color: $icsilab.getFooter().color ? $icsilab.getFooter().color : 'black'}" v-html="'&nbsp;|&nbsp;'"/>
                    <div class="md3" style="padding-right: 10px;cursor: pointer" @click="goToPage" :style="{color: $icsilab.getFooter().color ? $icsilab.getFooter().color : 'black'}">{{mentions_legales_label}}</div>
                </v-layout>
            </v-container>
        </v-flex>
    </v-footer>
</template>
<script>
    export default {
        name: "fx-footer",
        props: {
            fixed: {
                type: Boolean,
                default: true
            }
        },
        computed: {
          tous_droits_reserces_label() {
            if(process.env.VUE_APP_LANG === 'it') {
              return 'Tutti i diritti riservati'
            }
            return 'Tous droits réservés'
          },
          mentions_legales_label() {
            if(process.env.VUE_APP_LANG === 'it') {
              return 'Avviso legale'
            }
            return 'Mentions légales'
          }
        },
        methods: {
            goToPage() {
                if (this.$icsilab.getFooter().route_metions_legales) {
                    this.$icsilab.goToPage(this.$icsilab.getFooter().route_metions_legales)
                }
            }
        }
    }
</script>
